import { useStableNavigate } from "@mirage/hooks/useStableNavigate";
import { PrePublicPortalWLRoutingService } from "@prePublicPortalWestLindsay/services/PrePublicPortalWLRoutingService";
import { PreApplicationExternalInsertRecordSuccessResult } from "@shared/mirage/contracts/PrePublicPortal";
import { PrePublicPortalWlConstants } from "@shared/prePublicPortalWestLindsay/constants";
import { Link, Panel } from "govuk-react";
import { memo, useEffect } from "react";
import { useLocation } from "react-router-dom";

const router = new PrePublicPortalWLRoutingService();

export const PrePpWlSubmitSuccess = memo(() => {
    const location = useLocation();
    const navigate = useStableNavigate();
    const { state }: { state: PreApplicationExternalInsertRecordSuccessResult } = location;

    useEffect(() => {
        if (!state) {
            navigate(router.FormApplicantDetailsRoute());
        }
        return () => {
            location.state = undefined;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Panel title="Application received">
            Reference number
            <br />
            <strong>{state?.name || "(none)"}</strong>
            <br />
            <br />
            {state?.paymentUrl ? (
                <Link href={state?.paymentUrl} style={{ color: "#8bc9ff", textDecoration: "underline" }}>
                    <strong>Go to payment</strong>
                </Link>
            ) : (
                <strong>{PrePublicPortalWlConstants.CustomFeeContactMessage}</strong>
            )}
        </Panel>
    );
});
